import { ThemeConfig } from 'antd';

export type ThemeName = 'leedpulse' | 'leedflow';

export const leedpulseTheme: ThemeConfig = {
  token: {
    colorPrimary: '#6737ff',
    colorSuccess: '#00f7bf',
    colorWarning: '#ffc212',
    colorError: '#ff0022',
    colorInfo: '#9dccff',
    colorTextBase: '#2d3436',
    colorTextSecondary: '#636e72',
    colorBorder: '#efebff',
    colorText: '#2d3436',
    colorBgSpotlight: '#d2c2ff',
    // fontFamily: 'Work Sans', // not working
    controlHeight: 40,
    borderRadiusLG: 20,
  },
  components: {
    Card: {
      colorBorderSecondary: '#f0f0f0',
    },
    Button: {
      fontWeight: 500,
      paddingContentHorizontal: 24,
    },
    Form: {
      itemMarginBottom: 32,
    },
    // In the client app this is the actual value
    // Input: {
    //   activeShadow: "0px 0px 10px #0aafff59",
    // },
    Menu: {
      itemColor: '#636e72',
      itemHoverColor: '#2d3436',
      itemSelectedColor: '#2d3436',
      itemSelectedBg: '#f0ebff',
      itemHoverBg: '#00000005',
      itemActiveBg: '#00000010',
      activeBarBorderWidth: 2,
    },
    Table: {
      headerBg: '#EFEBFF',
    },
    Tooltip: {
      colorTextLightSolid: '#6737ff',
    },
    Select: {
      multipleItemBg: '#f0ebff',
    },
  },
};